import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, TransitionGroup as _TransitionGroup, createTextVNode as _createTextVNode, Transition as _Transition, isRef as _isRef, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "relative chat-history-inner" }
const _hoisted_2 = { class: "messages-list" }
const _hoisted_3 = {
  key: 0,
  class: "keep-online-message"
}
const _hoisted_4 = { class: "bottom-area" }
const _hoisted_5 = { key: "typing" }
const _hoisted_6 = { key: "fillContacts" }
const _hoisted_7 = { key: "requestRate" }
const _hoisted_8 = {
  class: "copyright",
  key: "copyright"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["innerHTML"]

import {
    ComponentInstance,
    ComponentPublicInstance,
    computed,
    getCurrentInstance,
    inject,
    nextTick,
    onMounted, Ref,
    ref,
    watch
} from 'vue';
import MessageStorage from "~/chat/ts/service/messages/MessageStorage";
import MessageWrapper from "~/chat/ts/data/chat/MessageWrapper";
import WindowHelper from "~/ts/library/WindowHelper";
import {ChatTabStore, PinnedMessageInterface} from "~/chat/ts/store/ChatTab";
import OperatorsSelect from "~/chat/vue/widget/operators/select/OperatorsSelect.vue";
import {ConfigStore} from "~/chat/ts/store/Config";
import ChatMessage from "~/chat/vue/widget/tabs/chat/ChatMessage.vue";
import CollectContacts from "~/chat/vue/widget/tabs/chat/CollectContacts.vue";
import {CHAT_OPEN_WIDGET, CHAT_SEND_MESSAGE_BY_CLIENT} from "~/chat/ts/Constants";
import Delay from "~/ts/library/Delay";
import ChatScrollContainer from "~/chat/vue/misc/ChatScrollContainer.vue";
import {WidgetStore} from "~/chat/ts/store/Widget";
import {ChatEventManagerInstance} from '~/chat/ts/ChatEventManager';
import WidgetMenuInChat from "~/chat/vue/widget/tabs/chat/WidgetMenuInChat.vue";
import RateRequestInChat from "~/chat/vue/widget/tabs/chat/RateRequestInChat.vue";
import {RATE_DISPLAY_TYPE_IN_CHAT_HISTORY} from "~/chat/ts/data/ISiteParams";
import {replaceUrlForChatIfNeeded} from "~/chat/ts/CommonConstants";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import {LightboxInjection} from "~/core-ui/ts/LightboxInjection";
import ChatPinnedMessage from "~/chat/vue/widget/tabs/chat/ChatPinnedMessage.vue";
import {__} from "~/ts/library/Translate";
import Device from "~/ts/library/Device";
import ChatMessageReactionSelector from "~/chat/vue/widget/tabs/chat/Reaction/ChatMessageReactionSelector.vue";
import ChatModalMenu from "~/chat/vue/widget/ChatModalMenu.vue";
import ChatModalMenuItem from "~/chat/vue/widget/ChatModalMenuItem.vue";
import ChatApiRequest from "~/chat/ts/service/request/ChatApiRequest";
import {SVG_LOADER_ANIMATION} from "~/chat/vue/widget/tabs/chat/SvgLoaderAnimation";



const __default__ = {
    name: "ChatHistory"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

_useCssVars(_ctx => ({
  "17cd2e4a": (_unref(buttonBackgroundColor))
}))

let historyWrapper = ref<ComponentPublicInstance>();//ref<ChatScrollContainer>();

let displayedCount = ref(15);
let messagesCount = ref<number>();
let isDisplayUnreadedCountAvailable = ref(false);

let buttonBackgroundColor = ConfigStore.siteParams.value.params.designParams.buttonSaveBg;

function isLast(i: number) {
    return i === lastMessageIndex.value;
}


let isRequestRateTypeInHistory = computed(() => {
    let type = siteParams.value.params.rate.requestRate.displayType;
    return !type || type == RATE_DISPLAY_TYPE_IN_CHAT_HISTORY;
});

let siteParams = ConfigStore.siteParams;

let borderStyle = computed(() => {
    return ConfigStore.design.value.dialog.border.bottom;
});

let rootClass = computed(() => {
    let result = ["relative", "d-flex", "vertical", "chat-history-root", "content-background"];
    if (borderStyle.value.round) {
        result.push("force-content-border-radius-bottom");
    }
    return result;
});

let chatHistoryWrapperStyle = computed(() => {
    let design = borderStyle.value;
    return {
        borderBottom: `${design.width}px solid ${design.color} !important`
    }
});

let isNeedToDisplayUnreadedMessagesCount = computed(() => {
    return !isScrolledToBottom.value && unreadedMessagesCount.value > 0;
});


let isOperatorsSelectDisplayed = ChatTabStore.isOperatorsSelectDisplayed;

let collectContacts = ChatTabStore.collectContacts;

let messages = computed(() => {
    let result = [];
    let prevMessage: MessageWrapper = null;
    for (let id of displayedMessageIdList.value) {
        let message = MessageStorage.getMessage(id);
        if (message) {
            let currentMessage = new MessageWrapper(message);

            currentMessage.setPreviousMessage(prevMessage);
            if (prevMessage) {
                prevMessage.setNextMessage(currentMessage);
            }
            result.push(currentMessage);
            prevMessage = currentMessage;
        } else {
            MessageStorage.removeMessage(id);
        }
    }
    return result;
});

let isScrolledToBottom = ChatTabStore.isScrolledToBottom;

let unreadedMessages = computed(() => {
    return MessageStorage.getUnreadedMessages();
});

let unreadedMessagesCount = computed(() => {
    return MessageStorage.getUnreadedMessageCount();
});


function getIdAttribute(messageId: string | number): string {
    return `online-chat-message-${messageId}`;
}

async function scrollTo(element: HTMLElement | "bottom" = null, duration: number = 300, offsetTop: number = -20) {
    try {
        await Delay.make(200, "chatHistoryScrollTo", true);
        let historyWrapper = getHistoryWrapper();
        if (historyWrapper) {
            if (!element) {
                for (let unreadedMessage of MessageStorage.getUnreadedMessages()) {
                    element = document.getElementById(getIdAttribute(unreadedMessage.id));
                    if (element) {
                        break;
                    }
                }
            }
            nextTick(() => {
                if (element && typeof element != "string") {
                    WindowHelper.scrollToElement(element, historyWrapper, duration, offsetTop);
                } else {
                    WindowHelper.scrollToBottom(historyWrapper, duration);
                }
            });
        }
    } catch (e) {
    }
}

let copyright = computed(() => {
    return siteParams.value.params.copyright;
});

let copyrightUrl = computed(() => {
    let result: string = null;
    if (copyright.value?.url) {
        result = replaceUrlForChatIfNeeded(copyright.value.url);
    }
    return result;
});

function getHistoryWrapper() {
    let wrapper = historyWrapper.value;
    return wrapper ? wrapper.$el as HTMLElement : null;
}

onMounted(() => {
    scrollTo(null, 0);
    setTimeout(() => {
        scrollTo();
    }, 300);
});

let isOpened = computed(() => {
    return WidgetStore.isOpened.value;
});

let displayedMessageIdList = computed(() => {
    return messageIdList.value.slice(-1 * displayedCount.value);
});

let hasPreviousMessages = computed(() => {
    return messageIdList.value.length > displayedMessageIdList.value.length;
});

let lastMessageIndex = computed(() => {
    return messages.value.length - 1;
});

let messageIdList = computed(() => {
    return MessageStorage.messageIdList;
});

let isOperatorTyping = computed(() => {
    return MessageStorage.isOperatorTyping;
});

let isShowFillContactsLink = computed(() => {
    return ChatTabStore.isShowFillContactsLink.value && !siteParams.value.free;
});

let showRateRequestAfterMessageId = computed(() => {
    let messageId = ChatTabStore.showRateRequestAfterMessage.value;
    if (messageId != null) {
        scrollTo("bottom");
    }
    return messageId;
});

let keepOnlineMessageInHistoryAfterMessageId = computed(() => {
    if (ConfigStore.siteParams.value.params.leadGen.keepOnline.isMessageInWidgetHistoryAfterSendEnabled) {
        let messageId = ChatTabStore.keepOnlineMessageInHistoryAfterMessage.value;
        if (messageId != null) {
            scrollTo("bottom");
        }
        return messageId;
    }
    return null;
});

let keepOnlineMessageInHistoryText = computed(() => {
    return ConfigStore.siteParams.value.params.leadGen.pmForm.textAfterSend;
});

let isShowRateRequestInFooter = ChatTabStore.displayRateRequestInFooter;

function showRateForm() {
    WidgetStore.openSendReview();
}


let showFillContactsLinkText = computed(() => {
    return ChatTabStore.dialogStartForm.value.afterStart.showAgain.text;
});

function showContactsForm() {
    ChatTabStore.askForContactsAfterStart();
}

let messageWithWidgetMenu = computed(() => {
    let prevMessage: MessageWrapper;
    for (let message of messages.value) {
        if (message.rawMessage.visitId === ConfigStore.visitId.value) {
            break;
        }
        prevMessage = message;
    }
    return prevMessage;
});


function onScrollTop() {
    if (hasPreviousMessages.value) {
        let wrapper = getHistoryWrapper();
        if (wrapper) {
            let height = wrapper.scrollHeight;
            let scrollTop = wrapper.scrollTop;
            displayedCount.value += 50;
            nextTick(() => {
                let newHeight = wrapper.scrollHeight;
                wrapper.scrollTop = scrollTop + newHeight - height;
            });
        }
    }
}

function onScrollBottom() {
    ChatTabStore.SET_IS_SCROLLED_TO_BOTTOM(true);
}

function onScrollMiddle() {
    ChatTabStore.SET_IS_SCROLLED_TO_BOTTOM(false);
}


async function onScroll() {
    if (WidgetStore.currentTab.value == WidgetStore.chatTab.value) {
        if (ChatTabStore.isHistoryDisplayed.value) {
            if (historyWrapper.value) {
                if (unreadedMessages.value.length) {
                    let scrollContainerRect = historyWrapper.value.$el.getBoundingClientRect();
                    for (let message of unreadedMessages.value) {
                        let element = document.getElementById(getIdAttribute(message.id));
                        if (element) {
                            element = element.querySelector(".message-text") || element;
                            let rect = element.getBoundingClientRect();
                            let top = rect.top - scrollContainerRect.top;
                            let bottom = top + rect.height;
                            if (bottom <= scrollContainerRect.height) {
                                MessageStorage.setMessageReaded(message.id);
                            }
                        }
                    }
                }
            }
        }
    }
}

async function onMessageHeightIncrease() {
    if (isScrolledToBottom.value) {
        scrollTo();
    }
}

let lightbox = inject(LightboxInjection, null);

let messageContextMenu: Ref<{
    visible: boolean,
    message: MessageWrapper
}> = ref<{
    visible: boolean,
    message: MessageWrapper
}>();

function onMessageClick(event: MouseEvent, message: MessageWrapper) {
    let target: HTMLImageElement = event.target as HTMLImageElement;
    let hasLink = false;
    let parent = target.parentElement;
    while (parent) {
        if (parent.tagName.toLowerCase() == "a") {
            hasLink = true;
            break;
        }
        parent = parent.parentElement;
    }
    if (!hasLink) {
        if (target.tagName.toLowerCase() == "img") {
            if (!target.classList.contains("emoji")) {

                if (lightbox) {
                    lightbox(target.src);
                    return;
                }
            }
        }
        if (!Device.desktop()) {
            messageContextMenu.value = {
                visible: true,
                message
            };
        }
    }


}

let isCopyAvailable = true;//window.location.protocol == "https:";
let copyInProgress = ref(false);


async function getTextForCopy(message: MessageWrapper) {
    let result = await ChatApiRequest.make({
        method: "getMessageTextVersion",
        p: {
            messageId: message.id
        }
    });
    copyInProgress.value = false;
    messageContextMenu.value = null;
    if (result.isSuccess()) {
        return result.data.text;
    } else {
        result.showMessage(instance);
        return "";
    }
}


async function copyMessage(message: MessageWrapper) {
    copyInProgress.value = true;
    try {
        if (typeof ClipboardItem && navigator.clipboard.write) {
            // NOTE: Safari locks down the clipboard API to only work when triggered
            //   by a direct user interaction. You can't use it async in a promise.
            //   But! You can wrap the promise in a ClipboardItem, and give that to
            //   the clipboard API.
            //   Found this on https://developer.apple.com/forums/thread/691873
            const text = new ClipboardItem({
                "text/plain": (async () => {
                    return new Blob([await getTextForCopy(message)], {type: "text/plain"});
                })()
            });
            navigator.clipboard.write([text])
        } else {
            let text = await getTextForCopy(message);
            navigator.clipboard.writeText(text)
        }
    } catch (e) {

    }
}

function replyMessage(message: MessageWrapper) {
    ChatTabStore.SET_REPLY_TO_MESSAGE_ID(message.id);
    messageContextMenu.value = null;
}


(() => {
    messagesCount.value = messageIdList.value.length;

    addDisposableEvent(
        ChatEventManagerInstance.addEventListener(CHAT_OPEN_WIDGET, () => {
            nextTick(() => {
                scrollTo(null, 0);
            });
        })
    );
    addDisposableEvent(
        ChatEventManagerInstance.addEventListener(CHAT_SEND_MESSAGE_BY_CLIENT, () => {
            scrollTo("bottom");
        })
    );
})();

watch(isNeedToDisplayUnreadedMessagesCount, async () => {
    if (isNeedToDisplayUnreadedMessagesCount.value) {
        await Delay.make(1000);
        if (isNeedToDisplayUnreadedMessagesCount.value) {
            isDisplayUnreadedCountAvailable.value = true;
        }
    } else {
        isDisplayUnreadedCountAvailable.value = false;
    }
});

let operatorsSelectRef = ref<ComponentInstance<any>>();

watch(isOperatorsSelectDisplayed, () => {
    if (isOperatorsSelectDisplayed.value) {
        nextTick(() => {
            scrollTo(operatorsSelectRef.value.$el as HTMLElement);
        });
    }
});

watch(messageIdList, (newList: number[]) => {
    let newCount = newList.length;
    let delta = newCount - messagesCount.value;
    if (delta > 0) {
        displayedCount.value += delta;
    }
    messagesCount.value = newCount;
    if (isScrolledToBottom.value) {
        scrollTo();
    }
});

let instance = getCurrentInstance().proxy;

async function showPinnedMessage(pinnedMessage: PinnedMessageInterface) {
    let messageId = pinnedMessage.id;
    let message = MessageStorage.getMessage(messageId);
    if (message) {
        let messageIdList = MessageStorage.messageIdList;
        let index = messageIdList.indexOf(messageId);
        if (index != -1) {
            displayedCount.value = Math.max(displayedCount.value, messageIdList.length - index);
            await Delay.make(10);
            let element = historyWrapper.value.$el.querySelector(`#${getIdAttribute(messageId)}`) as HTMLElement;
            if (element) {
                await scrollTo(element, 300, -80);
                element.classList.add("highlight");
                await Delay.make(500);
                element.classList.remove("highlight");
                return;
            }
        }
    }
    WidgetStore.showModalMessage({
        text: pinnedMessage.text,
        title: __("Закреплённое сообщение"),
        vue: instance,
        nl2br: true,

    })
}

/*
onMounted(() => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        console.log("enumerateDevices() не поддерживается.");
        return;
    }

// Перечисление в цикле камер и микрофонов
    navigator.mediaDevices
        .enumerateDevices()
        .then(function (devices) {
            devices.forEach(function (device) {
                sendMessage({
                    text: device.kind + ": " + device.label + "; id = " + device.deviceId + "; groupId = " + device.groupId,
                    callback: () => {
                    }
                });
                console.log(
                    device.kind + ": " + device.label + " id = " + device.deviceId,
                );
            });
        })
        .catch(function (err) {
            console.log(err.name + ": " + err.message);
        });
})*/


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(rootClass)),
    style: _normalizeStyle(_unref(chatHistoryWrapperStyle))
  }, [
    _createVNode(ChatPinnedMessage, { onShow: showPinnedMessage }),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "filler" }, null, -1)),
    _createVNode(ChatScrollContainer, {
      class: "chat-history-wrapper",
      ref_key: "historyWrapper",
      ref: historyWrapper,
      onScrollTop: onScrollTop,
      onScrollBottom: onScrollBottom,
      onScrollMiddle: onScrollMiddle,
      onScroll: onScroll
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (!_unref(messageWithWidgetMenu))
              ? (_openBlock(), _createBlock(WidgetMenuInChat, { key: "widget-menu-in-chat" }))
              : _createCommentVNode("", true),
            (_unref(isRequestRateTypeInHistory) && 0 === _unref(showRateRequestAfterMessageId))
              ? (_openBlock(), _createBlock(RateRequestInChat, { key: "request-rate-in-chat" }))
              : _createCommentVNode("", true),
            _createVNode(_TransitionGroup, {
              name: "list",
              tag: "div"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messages), (item, i) => {
                  return (_openBlock(), _createBlock(ChatMessage, {
                    key: item.key,
                    message: item,
                    "show-time": isLast(i) || _unref(siteParams).params.siteChatOptions.showTimeForAllMessages,
                    "is-last": isLast(i),
                    onHeightIncrease: onMessageHeightIncrease,
                    id: getIdAttribute(item.id),
                    onClickOnMessageContent: ($event: any) => (onMessageClick($event, item))
                  }, {
                    after: _withCtx(() => [
                      (item === _unref(messageWithWidgetMenu) || item.id === _unref(messageWithWidgetMenu)?.id)
                        ? (_openBlock(), _createBlock(WidgetMenuInChat, { key: "widget-menu-in-chat" }))
                        : _createCommentVNode("", true),
                      (_unref(isRequestRateTypeInHistory) && item.id === _unref(showRateRequestAfterMessageId))
                        ? (_openBlock(), _createBlock(RateRequestInChat, { key: "request-rate-in-chat" }))
                        : _createCommentVNode("", true),
                      (_unref(keepOnlineMessageInHistoryAfterMessageId) === item.id)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (_unref(keepOnlineMessageInHistoryText))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(keepOnlineMessageInHistoryText)), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["message", "show-time", "is-last", "id", "onClickOnMessageContent"]))
                }), 128)),
                (_unref(isOperatorsSelectDisplayed))
                  ? (_openBlock(), _createBlock(OperatorsSelect, {
                      ref_key: "operatorsSelectRef",
                      ref: operatorsSelectRef,
                      key: "operatorsSelect",
                      class: "mt-3"
                    }, null, 512))
                  : (_unref(collectContacts))
                    ? (_openBlock(), _createBlock(CollectContacts, {
                        "scroll-to-element": scrollTo,
                        class: "collect-contacts",
                        key: "collectContacts"
                      }))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_Transition, {
              name: "zoom",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_unref(isOperatorTyping))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(__)("TYPING_ANSWER")), 1))
                  : (_unref(isShowFillContactsLink))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("a", {
                          class: "link-dashed text-muted",
                          onClick: showContactsForm
                        }, _toDisplayString(_unref(showFillContactsLinkText)), 1)
                      ]))
                    : (_unref(isShowRateRequestInFooter))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("a", {
                            class: "link-dashed text-muted",
                            onClick: showRateForm
                          }, _toDisplayString(_unref(__)("RATE_OUR_WORK")), 1)
                        ]))
                      : (_unref(copyright).show)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createTextVNode(_toDisplayString(_unref(__)('CHAT_PROVIDED_BY')) + " ", 1),
                            _createElementVNode("a", {
                              target: "_blank",
                              href: _unref(copyrightUrl)
                            }, [
                              _createElementVNode("img", {
                                src: _unref(copyright).img.dark
                              }, null, 8, _hoisted_10)
                            ], 8, _hoisted_9)
                          ]))
                        : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_Transition, { name: "list" }, {
      default: _withCtx(() => [
        (_unref(isNeedToDisplayUnreadedMessagesCount) && _unref(isDisplayUnreadedCountAvailable))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "unreaded-messages-count cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollTo()))
            }, _toDisplayString(_unref(unreadedMessagesCount)), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_unref(messageContextMenu))
      ? (_openBlock(), _createBlock(ChatModalMenu, {
          key: 0,
          visible: _unref(messageContextMenu).visible,
          "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_unref(messageContextMenu).visible) = $event))
        }, {
          default: _withCtx(() => [
            (_unref(ConfigStore).siteParams.value.params.messageReactions?.length > 0)
              ? (_openBlock(), _createBlock(ChatModalMenuItem, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(ChatMessageReactionSelector, {
                      message: _unref(messageContextMenu).message,
                      popover: false,
                      onSelected: _cache[1] || (_cache[1] = ($event: any) => (_isRef(messageContextMenu) //@ts-ignore
 ? messageContextMenu.value = null : messageContextMenu = null))
                    }, null, 8, ["message"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(isCopyAvailable))
              ? (_openBlock(), _createBlock(ChatModalMenuItem, {
                  key: 1,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (copyMessage(_unref(messageContextMenu)?.message)))
                }, {
                  default: _withCtx(() => [
                    (_unref(copyInProgress))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "loader",
                          innerHTML: _unref(SVG_LOADER_ANIMATION)
                        }, null, 8, _hoisted_11))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_unref(__)("COPY")), 1)
                        ], 64))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(ChatModalMenuItem, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (replyMessage(_unref(messageContextMenu)?.message)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(__)("REPLY")), 1)
              ]),
              _: 1
            }),
            _createVNode(ChatModalMenuItem, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_isRef(messageContextMenu) //@ts-ignore
 ? messageContextMenu.value = null : messageContextMenu = null))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(__)("CLOSE")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true)
  ], 6))
}
}

})